import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"column-wide, colums"} maskId="square-filled-radius-0-stroke-1-IconColumnWide"><path d="M11.5 4H2V20H11.5V4Z" fill="currentColor"/><path d="M12.5 20H22V4H12.5V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumnWide;
